import type { MetaDescriptor } from 'react-router';

type PreloadImageProps =
  | {
      fetchPriority?: 'auto' | 'low' | 'high';
      sizes?: string;
      src?: string;
      srcSet?: string;
    }
  | string
  | undefined;

export const preloadImage = (props: PreloadImageProps): MetaDescriptor => {
  const { fetchPriority, sizes, src, srcSet } =
    typeof props === 'object'
      ? props
      : {
          fetchPriority: 'auto',
          sizes: undefined,
          src: props,
          srcSet: undefined,
        };

  return src
    ? {
        as: 'image',
        fetchpriority: fetchPriority,
        href: src,
        imageSizes: sizes,
        imageSrcSet: srcSet,
        rel: 'preload',
        tagName: 'link',
      }
    : {};
};
